import http from './http'
import { serialize } from 'object-to-formdata';
import qs from 'qs'

export default {
    /**
     * Consulta los roles
     * @returns {Promise}
     */
    all(query = {}) {
        return http.get(`roles?${qs.stringify(query)}`);
    },

    /**
     * Crea un nuevo rol.
     * @param {Object} rol 
     * @returns {Promise}
     */
    add(rol) {
        const formData = serialize(rol, {
            nullsAsUndefineds: true,
            booleansAsIntegers: true,
        })

        return http.post(`roles`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        })
    },

    /**
     * Actualiza un rol.
     * @param {int} rol 
     * @param {Object} payload 
     * @returns {Promise}
     */
    update(rol, payload) {
        const formData = serialize(payload, {
            nullsAsUndefineds: true,
            booleansAsIntegers: true,
        })

        formData.append("_method", 'PUT')

        return http.post(`roles/${rol}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        })
    },
}